module.exports = __webpack_public_path__ + "static/media/userBg.ceb6bf68.svg";